import './params';

export const backendApi = import.meta.env.VITE_BACKEND_API;
export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
export const environment = process.env.NODE_ENV;
